import { Component } from "react";
import NavTab from "../../../components/common/global_layout/navTab";
import { Container, Row } from "reactstrap";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import "../../../style/css/particulier/sideBarResult.css";
import AnnounceRow from "../../../components/common/announceRow";
import SideBarLocation from "../../../components/common/Cars/sideBarLocation";
import httpClient from "../../../httpClient";
import SideBarTransfert from "../../../components/common/Cars/sideBarTransfert";

class Menu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      /* Awesome State Not Yet Used */
    };
  }

  render() {
    return (
      <div
        className={`sidebar-menu${
          this.props.isMenuOpen === true ? " open" : ""
        }`}
      >
        <button
          type="button"
          className="close mt-1 mr-2"
          onClick={this.props.onMenuToggle}
        >
          <span aria-hidden="true">×</span>
        </button>
        <SideBarTransfert />
      </div>
    );
  }
}


class SearchTransfert extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMenuOpen: !(window.innerWidth < 680),
      widthSideBar: (330 / window.innerWidth) * 100,
      announces:this.props.announces || [],
      searchInfo:{},
      isLoading:true,
      searchedResult:true
    };
    this.toggleMenu = this.toggleMenu.bind(this);
    this.resultSlider = this.resultSlider.bind(this);
  }


  componentWillMount() {
    this.resultSlider();
    this.getAnnounces();
  }

  async getAnnounces(){
      let all = await httpClient.getAllCarsTransfert()
      this.setState({
          announces : all
      })
  }
  //slide result div with % compared to width menu (330px)
  resultSlider() {
    if (this.state.isMenuOpen === true) {
      if (window.innerWidth > 1480) {
        this.setState({ widthSideBar: (330 / window.innerWidth) * 100 - 2 });
      } else if (window.innerWidth < 680) {
        this.setState({ widthSideBar: 0 });
      } else {
        this.setState({ widthSideBar: (330 / window.innerWidth) * 100 });
      }
    } else if (this.state.isMenuOpen === false) {
      this.setState({ widthSideBar: 1 });
    }
  }

  async toggleMenu() {
    await this.setState({ isMenuOpen: !this.state.isMenuOpen });
    this.resultSlider();
  }


  render() {
    const cards = this.props.announces.map(function(item, i){
      return (
        <AnnounceRow
                  key={i}
                  id={123   }
                  img={`/imgs/CarsType/4X4.png`}
                  imgWidth="25%"
                  imgHeight="40px"
                  title={item.title}
                  announceDetails={item.description}
                  prix={item.parJrs.prix}
                  rating ={"item.rating"}
                  link={`/cars/${item._id}/carDetails/`}
                  position={"item.region"}
                  author={"item.creator"}
                  promotion
                  contact
                  details
                  favoris
                  addPanier
                />
      )
    })
    const isMenuOpen = this.state.isMenuOpen;
    return (
      <>
        <div className={`${isMenuOpen && "blk-over"}`}></div>
        <Menu
          isMenuOpen={this.state.isMenuOpen}
          onMenuToggle={this.toggleMenu}
        />
        <button
          type="button"
          className="sb-controller"
          onClick={this.toggleMenu}
        >
          Menu
        </button>
        <Container>
          <Row>
            <div
              className={`collabse-result_${
                this.state.isMenuOpen === true ? "open" : "close"
              }`}
              style={{ marginLeft: `${this.state.widthSideBar}%` }}
            >
              <NavTab display="none" position="fixed" />
              <div className="container d-flex flex-column align-items-center">
                 
                {cards}
                {cards.length === 0 &&  <h2 className="mt-5">No results</h2>}

              </div>
            </div>
            <div className="app-container"></div>
          </Row>
        </Container>
      </>
    );
  }
}
function mapStateToProps(state) {
  return {
    announces : state.sideBarCarsLocation.responseCarsLocation,
  };
}

//connect function INJECTS dispatch function as a prop!!
export default withRouter(connect(mapStateToProps)(SearchTransfert));
